"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var AIClients = function AIClients(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: 39.62,
    height: 39.62,
    x: 0.19,
    fill: "url(#AIClientsGradient)",
    rx: 19.81
  }), /*#__PURE__*/_react["default"].createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.988,
    d: "m15.556 7.86 1.063 2.158 2.38.346-1.721 1.68.403 2.38-2.125-1.12-2.133 1.12.404-2.38-1.722-1.68 2.38-.346 1.071-2.158ZM27.6 19.456l.997 2.018 2.223.322-1.614 1.573.379 2.215-1.985-1.046-1.993 1.046.379-2.215-1.606-1.573 2.224-.322.996-2.018ZM21.937 15.456l1.531 1.17a.823.823 0 0 1 .154 1.155L12.864 31.857a1.862 1.862 0 0 1-2.582.327 1.862 1.862 0 0 1-.349-2.609l10.638-13.919a.988.988 0 0 1 1.385-.185l-.019-.015ZM17.879 19.127l2.957 2.257M26.003 5.168l1.178 2.397 2.644.378-1.911 1.87.453 2.627-2.364-1.243-2.364 1.244.453-2.628-1.91-1.87 2.635-.378 1.186-2.397Z"
  }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "AIClientsGradient",
    x1: 10.176,
    x2: 39.113,
    y1: 29.725,
    y2: 1.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    offset: 0.09,
    stopColor: "#812DF2"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: 0.21,
    stopColor: "#6E3AF0"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: 0.72,
    stopColor: "#2572EB"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: 0.95,
    stopColor: "#0989E9"
  }))));
};
var _default = exports["default"] = AIClients;